import { axiosGet } from '@/api/handlers';
import { t } from '@/i18n';
import { downloadFile } from '@/utils';
import axios from 'axios';
import type { z } from 'zod';
import {
  type AttachmentBaseModel,
  SanitizedAttachmentModel,
} from '../_models/attachment';

const getSanitizedFileUrl = async (attachmentId: string) => {
  try {
    const res = await axiosGet(
      `/api/attachments/${attachmentId}/sanitized-download-url/`,
    );

    return SanitizedAttachmentModel.parse(res).url;
  } catch {
    throw new Error(t('error-message-file-sanitize-failed'));
  }
};

export const downloadAttachment = async (
  attachment: z.infer<typeof AttachmentBaseModel>,
) => {
  try {
    const fileUrl =
      attachment.url ?? (await getSanitizedFileUrl(attachment.id));

    const response = await axios.get(fileUrl, {
      responseType: 'blob',
    });

    const blob = new Blob([response.data]);

    downloadFile(blob, attachment.fileName);
  } catch {
    throw new Error(t('error-message-file-download-failed'));
  }
};
